import { Component, OnInit } from '@angular/core';
import { AuthService } from '@shared/auth/auth.service';

@Component({
  selector: 'app-mfa',
  templateUrl: './mfa.component.html',
  styleUrls: ['./mfa.component.scss']
})
export class MfaComponent implements OnInit {

  constructor(public authService: AuthService) { }

  EMAIL:string = "Email";
  TEXT:string = "Text";
  deliveryMethod: string = "";  
  deliveryReceipient: string = "";
  code: string = "";
  recipient: string = "";
  processing: boolean = false;
  getCodeDisabled: boolean = true;
  validateCodeDisabled: boolean = false;
  step: number = 1;
  supportedDeliveryMethods: string[] = [this.EMAIL, this.TEXT];

  ngOnInit(): void {
       this.deliveryMethod = this.EMAIL;
       this.onDeliveryMethodChange();
  }

  onDeliveryMethodChange() {
    
     this.getCodeDisabled = true;
     this.deliveryReceipient = "";
     this.code = "";

     if(this.deliveryMethod == null || this.deliveryMethod.length == 0){
       return;
     }

     if(this.deliveryMethod == this.EMAIL){
       if(this.authService.getUser()?.email == null || this.authService.getUser()?.email?.length == 0) {   
        return;
       }
       this.deliveryReceipient = this.authService.getUser()?.email;
       this.getCodeDisabled = false;
     }
     else if(this.deliveryMethod == this.TEXT) {
       let textRecipient = this.getTextRecipient();
      if(textRecipient == null || textRecipient.length == 0) {  
       return;
      }
      this.deliveryReceipient = textRecipient;
      this.getCodeDisabled = false;
     }

     return;
     
  }

  // getCode() {
  //   this.code = "";
  //   this.getCodeDisabled = true;
  //   this.authService.sendCode(this.deliveryMethod, this.deliveryReceipient).subscribe(u => {
  //     this.step = 2;
  //   },
  //   error => {
  //     console.error('error: ' + error.statusText);
  //     this.getCodeDisabled = false;
  //   });

  // }

  // resend() {
  //   this.step = 1;
  //   this.code = "";
  //   this.getCodeDisabled = false;
  // }

  // validateCode() {
  //   this.validateCodeDisabled = true;
  //   this.authService.validateCode(this.code).subscribe(u => {
  //     this.step = 3;
  //     this.authService.updateTimestamp();
  //     this.validateCodeDisabled = false;
  //   },
  //   error => {
  //     console.error('error: ' + error.statusText);
  //     this.validateCodeDisabled = false;
  //   });
  // }

  private getTextRecipient(): string {
    if(this.authService.getUser()?.mobile != null && this.authService.getUser()?.mobile?.length > 0){
      return this.authService.getUser()?.mobile;
    }
    return this.authService.getUser()?.phone;
  }

}
